import { create } from 'zustand';

import UIConfig from '@/UIConfig.ts';

export interface HeaderColors {
  backgroundColor: string;
  logoColor: string;
}

interface HeaderState extends HeaderColors {
  isLogoVisible: boolean;
  previousColors: HeaderColors | null;
  setHeaderColors: (
    params: Partial<HeaderColors> & { isLogoVisible?: boolean }
  ) => void;
  switchHeaderColors: (type: 'light' | 'dark') => void;
  setAsDefaultColors: (colors: HeaderColors) => void;
  setLogoVisible: (visible: boolean) => void;
}

export const useHeaderStore = create<HeaderState>((set, get) => ({
  backgroundColor: UIConfig.Colors.BackgroundWhite,
  logoColor: UIConfig.Colors.BackgroundDark,
  previousColors: null,
  isLogoVisible: true,

  setHeaderColors: (params) => {
    const { backgroundColor, logoColor, isLogoVisible } = params;

    set((state) => ({
      ...state,
      ...(backgroundColor && { backgroundColor }),
      ...(logoColor && { logoColor }),
      ...(typeof isLogoVisible === 'boolean' ? { isLogoVisible } : {})
    }));
  },

  switchHeaderColors: (type) => {
    const { backgroundColor, logoColor } = get();

    // сохраняем предыдущие цвета перед переключением
    set({ previousColors: { backgroundColor, logoColor } });

    if (type === 'light') {
      set({
        backgroundColor: UIConfig.Colors.BackgroundWhite,
        logoColor: UIConfig.Colors.BackgroundDark
      });
    } else if (type === 'dark') {
      set({
        backgroundColor: UIConfig.Colors.BackgroundDark,
        logoColor: UIConfig.Colors.BackgroundWhite
      });
    }
  },

  setAsDefaultColors: (colors) =>
    set({
      ...colors,
      previousColors: null
    }),

  setLogoVisible: (visible) => set({ isLogoVisible: visible })
}));
